module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Compose New Message</h1>\n\n';
 if(!has_loaded){ 
__p+='\n<div class="processing">\n    <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n    Fetching your messaging settings...\n</div>\n';
 } 
__p+='\n\n<div class="messaging-hook"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./names/templates/messaging.html
// module id = 349
// module chunks = 0